import { EkranBledu } from '@insolitum/ui';
import { Link, useNavigate } from 'react-router-dom';

/**
 * Nie znaleziono (404) — adres, pod którym powłoka nie ma ekranu.
 *
 * Do 05.10.2026 stało tu ciche `<Navigate to="/" replace />`. Wyglądało
 * uprzejmie, a było ślepakiem: link z maila, z Stripe'a albo z dokumentacji
 * prowadzący donikąd lądował na stronie głównej bez słowa, więc nikt nie
 * zgłaszał, że adres jest zły — wyglądało, jakby zadziałał. Dlatego ekran
 * mówi wprost, co się stało, i nie przekierowuje sam.
 *
 * Adresy, które system już wydał na zewnątrz, mają w `App.tsx` jawne aliasy;
 * pilnuje tego `tests/unit/apps/trasyPowloki.test.ts`. Ten ekran jest dla
 * reszty: literówek, starych zakładek i linków, których jeszcze nie znamy.
 *
 * „Wróć" tylko wtedy, gdy jest dokąd: link otwarty z maila w nowej karcie ma
 * historię długości 1, a `navigate(-1)` byłby tam przyciskiem bez skutku.
 */
export function NieZnalezionoPage() {
  const navigate = useNavigate();
  const jestDokadWrocic = window.history.length > 1;

  return (
    <EkranBledu
      wariant="nie-znaleziono"
      uklad="pelny"
      akcje={
        <>
          <Link to="/" className="btn btn--primary btn--lg">
            Przejdź do pulpitu
          </Link>
          {jestDokadWrocic ? (
            <button
              type="button"
              onClick={() => navigate(-1)}
              className="btn btn--secondary btn--lg"
            >
              Wróć do poprzedniej strony
            </button>
          ) : null}
        </>
      }
    />
  );
}
